import React, { useState, useEffect } from "react";
import { StaticContainer } from "../../components/wrappers/staticContainer";

import { Redirect } from "react-router-dom";

import { AccountContent } from "./content";
import { useUser } from "../../MVVM/Hooks/useUser";

export default function Account(props) {
  const { allstarUser, getFreshProfile } = useUser();

  useEffect(() => {
    getFreshProfile();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!allstarUser.loggedIn) {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let referrer = params.get("referrer");
    if (referrer) return <Redirect to={`/login?${params}`} />;
    return <Redirect to="/login" />;
  }

  return (
    <StaticContainer>
      <AccountContent {...props} />
    </StaticContainer>
  );
}
